"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAproxValue = withAproxValue;
var _react = _interopRequireDefault(require("react"));
require("./AproxInput.css");
var _excluded = ["isAprox"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function withAproxValue(WrappedComponent) {
  return function ApproxValueInput(_ref) {
    var isAprox = _ref.isAprox,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isAprox && /*#__PURE__*/_react["default"].createElement("span", {
      className: "number-input__aprox-sign"
    }, "\u2248"), /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, props, {
      className: isAprox ? 'input--number__approx' : ''
    })));
  };
}